export class Paginator<T> {
  data: Array<T>;
  links: {
    first: string,
    last: string,
    next: string,
    prev: string,
  };
  meta: {
    current_page: number;
    from: number;
    last_page: number;
    path: string;
    per_page: string;
    to: number;
    total: number;
  };

  constructor(data: any) {
    this.data = data.data;
    this.links = data.links;
    this.meta = data.meta;
  }


}
